import React from 'react';
import ReactDOM from 'react-dom';
import ReactGA from 'react-ga';
import { Provider } from 'react-redux';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import viaStore from './state/viaStore';

// Google Analytics
if (process.env.REACT_APP_GANALYTICS) {
  ReactGA.initialize(process.env.REACT_APP_GANALYTICS);
} else {
  console.warn('Google analyics id has not been defined. Analytics is not enabled.'); // eslint-disable-line no-console
}

ReactDOM.render((
  <Provider store={viaStore}>
    <App />
  </Provider>
), document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
